<div class="modal fade modal--alert" id="images-of-damage-modal-alt" tabindex="-1" role="dialog"
  aria-labelledby="images-of-damage-modal-alt" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading modal-alert__heading--flush">
        <div class="container">
          <button class="modal-alert__close" (click)="cancelChanges()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <h3 class="font-normal mb-30 mt-50 mt-md-20"
          id="images-of-damage-modal-alt-title">{{question?.question_copy}}</h3>
          <div class="form-group mb-30">
            <label class="mb-15">{{question?.question_prompt}}</label>
            @if (question?.question_help) {
              <div class="note note--sm note--info mb-15 mb-md-20">
                <div class="note__icon">
                  <svg class="icon">
                    <use xlink:href="#info-small"></use>
                  </svg>
                </div>
                <!--<div class="note__content">
                <p [innerHTML]="question?.question_help"></p>
              </div>-->
            </div>
          }
          <div class="custom-upload custom-upload--media dz-clickable" id="uploader-alt-{{uniqueId}}">
            <div class="custom-upload__dropzone dz-default">
              <div class="custom-upload__thumb">
                <img src="assets/img/upload-image.svg">
              </div>
              <div class="custom-upload__instructions">
                <p>Tap to add files</p>
                <svg class="icon">
                  <use xlink:href="#upload"></use>
                </svg>
                <p>Drag &amp; drop files here or <strong>browse</strong></p>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="mb-15">Add a note (optional)</label>
          <textarea
            id="upload-text"
            [(ngModel)]="uploadText"
            placeholder="Start typing…"
            rows="7"
            class="form-control">
          </textarea>

        </div>
        <div class="container mt-20 ">
          <div class="row justify-content-start">
            <a href="javascript:;" class="button-control text-color-grey-6" id="images-of-damage-modal-delete">
              <svg class="icon">
                <use xlink:href="#trash-bin"></use>
              </svg>
              Delete
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-alert__button">
      <div class="container">
        <a href="javascript:void(0);" (click)="cancelChanges()" class="button button--lg button--secondary">Cancel</a>
        <a href="javascript:void(0);" (click)="saveChanges()" id='save-changes'
        class="button button--lg  button--primary" [attr.disabled]="buttonDisabled ? true : null">Save and Close</a>
      </div>
    </div>

  </div>
</div>
</div>
